import { template as template_9c20a9b2a70e41248f4531e3e29d5070 } from "@ember/template-compiler";
import AttachTooltip from 'ember-attacher/components/attach-tooltip';
import SpdsInfoSecondaryBadge from 'ember-simplepractice/components/spds/indicator/badge/info/secondary';
import styles from './marketing-info-list.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
export default template_9c20a9b2a70e41248f4531e3e29d5070(`
  {{#if @line}}
    <div class="{{styles.component}} marketing-info-line" ...attributes>
      {{svgJar @icon class="meta-line-icon" aria-hidden="true"}}
      <span class="meta-line-text">
        {{@line.visibleText}}{{#if @line.overflowCount}}
          <span
            class="meta-line-overflow"
            tabindex="0"
            data-test-marketing-info-overflow
            aria-label={{@line.overflowText}}
          >
            <SpdsInfoSecondaryBadge @size="small" aria-hidden="true">
              +{{@line.overflowCount}}
            </SpdsInfoSecondaryBadge>
            <AttachTooltip
              @placement="top"
              @class="tooltip align-left clinician-search-card-overflow-tooltip"
            >
              {{@line.overflowText}}
            </AttachTooltip>
          </span>
        {{/if}}
      </span>
    </div>
  {{/if}}
`, {
    eval () {
        return eval(arguments[0]);
    }
});
